import React, { useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'
import { Tooltip, Typography } from 'antd'
import { getRequest } from '../../../../services/base'
import SelectInput from '../../../common/SelectInput'
import InlineCheckbox from '../../../common/InlineCheckbox'
import { useIntl } from 'react-intl'

const CloneMappings = ({ formRef, payload, setPayload }) => {
  let { dtc_id, vehicle } = useParams()
  const intl = useIntl()
  const [dtcsOptions, setDtcsOptions] = useState([])
  const [searchFailed, setSearchFailed] = useState(false)

  useEffect(() => {
    getDtcsOptions('')
  }, [])

  const getDtcsOptions = async (search = '') => {
    let res = await getRequest(
      `/api/dtcs/dtcs_options/${dtc_id}/?vehicle_id=${vehicle}&search=${search}`
    )
    // Search-as-you-type: shown in the dropdown, not as a toast per keystroke.
    if (res?.status === false) {
      setSearchFailed(true)
      setDtcsOptions([])
      return
    }
    setSearchFailed(false)
    setDtcsOptions(res?.data || [])
  }

  const getInitialValues = () => {
    return {
      target_dtcs_ids: payload?.target_dtcs,
      clone_with_existing_mapping: payload?.clone_with_existing_mapping,
      create_dtc_circuits: payload?.create_dtc_circuits,
    }
  }

  useEffect(() => {
    if (!formRef) return

    formRef.setFieldsValue(getInitialValues())
  }, [formRef, payload])

  return (
    <>
      <SelectInput
        name="target_dtcs_ids"
        isMulti={true}
        options={dtcsOptions}
        value={payload?.target_dtcs}
        placeholder={intl.formatMessage({ id: 'dtcs.clone.selectDtcPlaceholder' })}
        showLoader={dtcsOptions?.length < 1}
        isRequired={false}
        onInputChange={(value) => {
          if (value) {
            getDtcsOptions(value)
          }
        }}
        notFoundContent={
          searchFailed ? (
            <Typography.Text type="danger" style={{ color: 'var(--color-form-link-danger)' }}>
              {intl.formatMessage({ id: 'generic.searchFailed' })}
            </Typography.Text>
          ) : undefined
        }
        onChange={(selectedOptions) => {
          setPayload({
            ...payload,
            target_dtcs: selectedOptions.map((o) => {
              return {
                label: o.label,
                description: o.description,
                value: o.value,
              }
            }),
          })
        }}
        formatOption={(option) => (
          <>
            <div className="option-label">{option.label}</div>
            <div className="option-description">{option.description}</div>
          </>
        )}
        formatLabel={(option) => {
          return (
            <>
              <div className="option-label">{option.label}</div>
              <div className="option-description">{option.description}</div>
            </>
          )
        }}
        filterOption={(input, option) => {
          return (option?.label + ' ' + option?.description)
            .toLowerCase()
            .includes(input.toLowerCase())
        }}
        maxTagCount="responsive"
        maxTagPlaceholder={(omittedValues) => (
          <Tooltip title={omittedValues.map((v) => v.label).join(', ')}>
            <span>+{omittedValues.length}</span>
          </Tooltip>
        )}
      />

      {payload?.target_dtcs?.length > 0 && (
        <>
          <InlineCheckbox
            name="clone_with_existing_mapping"
            label={intl.formatMessage({ id: 'dtcs.clone.cloneExistingMappings' })}
            value={payload?.clone_with_existing_mapping}
            wrapperClass="justify-items-evenly"
            onChange={(value) => {
              setPayload({ ...payload, clone_with_existing_mapping: value })
            }}
          />
          <InlineCheckbox
            name="create_dtc_circuits"
            label={intl.formatMessage({ id: 'dtcs.clone.withCircuitFilters' })}
            value={payload?.create_dtc_circuits}
            wrapperClass="justify-items-evenly"
            onChange={(value) => {
              setPayload({ ...payload, create_dtc_circuits: value })
            }}
          />
        </>
      )}
    </>
  )
}

CloneMappings.propTypes = {}

export default CloneMappings
